import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { getters } from '@/modules/core/app/helpers/store';
import { AppModule } from '@/modules/core/app/constants/app.constants';

export class ExportTemplatesRouteConfig extends PageRouteConfig {
  /**
   * @override
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const userSettings = getters.session.getUserSettings();
    return (
      userSettings.isModuleAvailable(AppModule.ADFLO_PROPOSAL) ||
      userSettings.isModuleAvailable(AppModule.STELLAR)
    );
  }
}
